import * as types from './types';

export const setLoading = (isLoading = true, questionType) => ({
  type: types.SCHOOL_ADMIN_QUESTION_POOL_SET_LOADING,
  isLoading,
  questionType
});

export const getSchoolAdminQuestions = (schoolId, questionType, queryParams) => ({
  type: types.SCHOOL_ADMIN_QUESTION_POOL_GET_QUESTIONS,
  schoolId,
  questionType,
  queryParams
});


export const setSchoolAdminQuestions = (questions, questionType) => ({
  type: types.SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTIONS,
  questions,
  questionType
});

export const setSchoolAdminQuestionActivationState = (schoolId, questionType, questionId, state, queryParams ) => ({
  type: types.SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTION_ACTIVATION_STATE,
  schoolId,
  questionType,
  questionId,
  state,
  queryParams 
});

export const setQuestionActivationLoading = (isLoading = true) => ({
  type: types.SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTION_ACTIVATION_STATE_UPDATING,
  isLoading
})

export const setSchoolAdminQuestionsQueryParams = (queryParams) => ({
  type: types.SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTIONS_QUERY_PARAMS,
  queryParams
});


// WEBPACK FOOTER //
// ./src/actions/school-admin/question-pool/index.js